import { ApiClient } from '@/services/api/apiClient.ts'

export class ApiClientFactory {
  private static instances = new Map<string, ApiClient>()

  /**
   * Get an API client instance for a specific base URL
   * @param baseURL - The base URL for the API client
   * @returns An API client instance
   */
  static getInstance(baseURL: string): ApiClient {
    if (!this.instances.has(baseURL)) {
      this.instances.set(baseURL, new ApiClient(baseURL))
    }
    return this.instances.get(baseURL)!
  }
}
